import { eHierarchyLevel } from "./api/enums";
import { HierarchyReadDto } from "./api/hierarchy/HierarchyReadDto";

/**
 * Gets the specified hierarchy and its parent hierarchies.
 *
 * @param id - The unique identifier
 * @param hierarchyNodes - The available hierarchy nodes
 */
export const getThisAndParentHierarchies = (
  id: string,
  hierarchyNodes: HierarchyReadDto[],
): HierarchyReadDto[] => {
  const ret: HierarchyReadDto[] = [];
  // Get first node
  let current = hierarchyNodes.find((h) => h.id === id && h.level !== eHierarchyLevel.TopLevel);
  // Loop through parents
  while (current) {
    ret.push(current);
    current = hierarchyNodes.find(
      (h) => h.id === current!.parentId && h.level !== eHierarchyLevel.TopLevel,
    );
  }
  return ret;
};
